module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_backlink":"New backlink","lost_backlink":"Lost backlink"},"fr":{"new_backlink":"Nouveau backlink","lost_backlink":"Backlink perdu"},"de":{"new_backlink":"Nouveau-Backlink","lost_backlink":"Backlink perdu"}}')
  delete Component.options._Ctor
}
